export const recipe = {
  f2f_url: "http://food2fork.com/view/35382",
  image_url:
    "http://static.food2fork.com/Jalapeno2BPopper2BGrilled2BCheese2BSandwich2B12B500fd186186.jpg",
  ingredients: [
    "2 jalapeno peppers, cut in half lengthwise and seeded",
    "2 slices sour dough bread",
    "1 tablespoon butter, room temperature",
    "2 tablespoons cream cheese, room temperature",
    "1/2 cup jack and cheddar cheese, shredded",
    "1 tablespoon tortilla chips, crumbled"
  ],
  publisher: "Closet Cooking",
  publisher_url: "http://closetcooking.com",
  source_url:
    "http://www.closetcooking.com/2011/04/jalapeno-popper-grilled-cheese-sandwich.html",
  title: "Jalapeno Popper Grilled Cheese Sandwich"
};
